"use strict";

var novicell = novicell || {}; // eslint-disable-line

novicell.faq =
  novicell.faq ||
  new (function () {
    this.init = function () {
      let overlay = document.querySelector(".faq-overlay");
      if (!overlay) {
        return;
      }
      // Overlay functionality
      closeOutsideOverlay();

      let overlayOpen = false;
      let bg = document.querySelector(".faq-bg");
      let body = document.querySelector("body");
      let openFaqBtn = document.querySelector(".login-guide__link");

      openFaqBtn.addEventListener("click", () => {
        openOverlay();
      });

      if (overlay) {
        let closeFaqBtn = overlay.querySelectorAll(".faq-overlay__close");
        closeFaqBtn.forEach((btn) => {
          btn.addEventListener("click", () => {
            closeOverlay();
          });
        });
      }

      function openOverlay() {
        overlay.classList.add("show-overlay");
        bg.classList.add("show-bg");
        body.classList.add("lock-scroll");
        overlayOpen = true;
      }

      function closeOverlay() {
        overlay.classList.remove("show-overlay");
        bg.classList.remove("show-bg");
        body.classList.remove("lock-scroll");
        overlayOpen = false;

        for (const header of headers) {
          header.dataset.showAnswer = "";
        }
      }

      function closeOutsideOverlay() {
        document.addEventListener("click", (e) => {
          const isClosest = e.target.closest(".faq-overlay");

          if (!isClosest && overlayOpen && e.target !== openFaqBtn) {
            closeOverlay();
          }
        });
      }

      // Accordion functionality
      let headers = document.querySelectorAll(".faq-overlay__question-header");

      for (const header of headers) {
        header.dataset.showAnswer = "";
        header.addEventListener("click", () => {
          if (header.dataset.showAnswer) {
            header.dataset.showAnswer = "";
          } else {
            header.dataset.showAnswer = true;
          }

          toggleQuestion(header.parentElement, header.dataset.showAnswer);
        });
      }

      function toggleQuestion(question, showAnswer) {
        const answer = question.querySelector(".faq-overlay__question-content");
        let arrows = question.querySelectorAll(
          ".faq-overlay__question-arrow-img"
        );
        if (showAnswer) {
          let answerHeight = `${answer.scrollHeight}px`;
          answer.style.maxHeight = answerHeight;
          arrows.forEach((arrow) => {
            arrow.classList.add("rotate-arrow");
          });
        } else {
          answer.style.maxHeight = "0px";
          arrows.forEach((arrow) => {
            arrow.classList.remove("rotate-arrow");
          });
        }
      }
    };
  })();
